export default {
  init() {
    function setAdsCookie(key, hours, value) {
      hours = hours === undefined ? 6 : hours;
      value = value === undefined ? 1 : value;
      var date = new Date();
      date.setTime(date.getTime() + hours * 60 * 60 * 1000);
      console.log(date);
      $.cookie(key, value, { expires: date });
    }

    function getAdsCookie(key) {
      return $.cookie(key);
    }
    $('.sl-tournament').change(function(){
      window.location.href = $('select#form-ltd').val();
    });
    jQuery('.list-odds a').click(function () {
      jQuery('.list-odds a').removeClass('active');
      jQuery(this).parent().addClass('active');
      const filter = jQuery(this).data('filter');
      var url = '';
      jQuery('#odds_main').html('<span class="loading"></span>');
      if (filter == 0) url = 'https://tyle.p2pcdn.xyz/tylekeohomnay2.html?noc=' + Number(new Date());
      else url = 'https://tyle.p2pcdn.xyz/tylechinhxac2.html?noc=' + Number(new Date());
      jQuery.get(url, function (res) {
          if (res.length > 0) {
              jQuery('#odds_main').html(res);
          }
      });
      return false;
  });
    function sticky_banner() {
      try{
          var scroll = jQuery(window).scrollTop(),
          banner_left = jQuery('#dnn_float_left').width(),
          banner_right = jQuery('#dnn_float_right').width(),
          footer = jQuery('.page-footer').offset().top,
          offset_width = jQuery('#app .container.main').offset(),
          main_menu = jQuery('.section-menu').height();
          if((scroll+jQuery('#dnn_float_right').height()) < footer){
          jQuery('#dnn_float_left').css({
              top: main_menu,
              display: 'block',
              left: (offset_width.left - banner_left) - 5,
          });
          jQuery('#dnn_float_right').css({
              top: main_menu,
              display: 'block',
              right: (offset_width.left - banner_right) - 5,
          });
          }
      }catch(error){
          console.log(error)
      }
    }
    sticky_banner();

    jQuery(window).on('load resize scroll', function() {
        sticky_banner();
    });
    if(jQuery('#toc_container').length !== 0 && jQuery('body.single').length == 0){
      jQuery('#toc_container').detach().appendTo('.toc-fixed');  
    }else{
      jQuery('.section__desc .content').parent().removeClass('col-8').addClass('col-lg-12');
    }
    function checkAdsRedirectPopup(index=0) {
      try {
        if (jQuery('.redirectPopup').length > 0) {

            index = index === undefined ? 0 : index;
            if (!window.adsRedirectPopups)
                return;

            // var arAdsRedirectPopups = $.parseJSON(adsRedirectPopups);
            // if (!arAdsRedirectPopups)
            //     return;
            var adsRedirectPopup = window.Shuffle(window.adsRedirectPopups)[index];
            if (!adsRedirectPopup)
                return;
            var cookieName = 'adsRedirectPopup2';
            if (getAdsCookie(cookieName) === undefined || getAdsCookie(cookieName) == null) {
                setAdsCookie(cookieName, 1);
                var link = adsRedirectPopup.link;
                jQuery('.redirectPopup').each(function() {
                    jQuery(this).attr('target', '_blank');
                    jQuery(this).attr('rel', 'nofollow');
                    jQuery(this).attr('data-href', jQuery(this).attr('href'));
                    jQuery(this).attr('href', link);
                    jQuery(this).addClass('redirectA');
                });
            } else {
                if ((index + 1) < window.adsRedirectPopups.length) {
                    checkAdsRedirectPopup((index + 1));
                }
            }
        }
      } catch (err) {console.log(err);}
    }
    checkAdsRedirectPopup();
    jQuery(document).ready(function($) {
      jQuery(document).on('click', '.redirectA', function() {
        var popupEnabled = $.cookie('adsPopup');
        var href = jQuery(this).attr('data-href');
        if (popupEnabled && popupEnabled !== undefined) {
            window.location.href = href;
            return false;
        } else {
            setTimeout(function() {
                window.location.href = href;
            }, 2000);
        }
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js